module.exports = __webpack_public_path__ + "img/巡检计划.98e11b25.png";